module.exports = __webpack_public_path__ + "img/title-4.ea377ed4.png";